<template>
      <page-header></page-header>

      <div class="container-sm">
        <div class="innerBannerText">
          <h2>BUSINESS OPPORTUNITY</h2>
          <h4>Contract Courier Drivers</h4>
          <br>

          <p>Postmedia is looking for independent contract delivery drivers to perform delivery services. Independent contractors must have a valid driver’s license. As this job is at your own pace, the faster you work, the more earnings, the potential is up to you!</p>

          <p>As an independent contractor, you will have a solid customer service track record in the delivery/distribution field and will provide an infrastructure that supports the delivery of Postmedia parcels and other associated products. Previous delivery driver experience is preferred.</p>

          <p>Independent contractors are required to provide their own WCB/WSIB coverage.</p>

          <p>Deliveries are Daily in this 7 day a week contract. You will be delivering Parcels to residential and commercial customers daily, as well as the provincial papers on Wednesday, Thursday and Saturdays.</p>

          <p>A once per week contract is also available in select areas for weekly flyer distribution.</p>

          <p>Core responsibilities for the independent contractor delivery driver include:</p>
          <ul>
              <li>Sorting & scanning your assigned packages for the day</li>

              <li>Carefully loading the parcels into your personal vehicle for delivery (Van/SUV is optimal for success)</li>

              <li>Delivering the parcels to the customer’s doorstep</li>

              <li>Taking photos of the delivered parcels through our parcel app</li>
          </ul>
          <p>The independent contract delivery driver must:</p>
          <ul>

              <li>Be 18 years of age or older</li>

              <li>Have their own WCB/WSIB coverage</li>

              <li>Have a valid G class driver's license or equivalent with a minimum of 2 years driving experience</li>

              <li>Have a valid auto insurance with minimum coverage limits of $1,000,000 CAD</li>

              <li>Vehicle in good working order</li>

              <li>Have a mobile device so we can set you up on our delivery app.</li>

              <li>Be available to work 5-7 days a week (and available on call, as needed, to cover emergency parcel delivery</li>
          </ul>
  
          <p>Paid by the piece delivered.</p>
        </div>
      </div>
      <div id="driveForUs">
        <form class="supportForm" action="">
          <div class="mb-3 row">
            <div class="mb-3 col-5">
              <h5 class="my-5 personal-head text-black">
                <span>CONTACT INFORMATION</span>
              </h5>
              <div class="col-md-10">
              <div class="mb-4 row">
                <label class="col-sm-4 col-form-label"
                  >Full Name<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    name="fullname"
                    v-model="full_name_drive"
                    required=""
                  />
                </div>
              </div>
              </div>
              <div class="col-md-10">
              <div class="mb-3 row">
                <label class="col-sm-4 col-form-label"
                  >Email address<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="email"
                    class="form-control drive_email_address"
                    name="email"
                    v-model="email_address_drive"
                    required=""
                  />
                </div>
              </div>
              </div>
              <div class="col-md-10">
              <div class="mb-3 row">
                <label class="col-sm-4 col-form-label"
                  >Phone number<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="tel"
                    class="form-control drive_phone_number"
                    name="phoneNumber1"
                    required=""
                    placeholder="XXX XXX XXXX"
                    v-model="phone_drive"
                    pattern="[0-9]{3} [0-9]{3} [0-9]{4}"
                    maxlength="12"
                  />
                </div>
              </div>
              </div>
            </div>
            <div class="mb-1 col-1"></div>
            <div class="mb-3 col-5">
              <h5 class="my-5 personal-head text-black">
                <span>MAILING ADDRESS</span>
              </h5>
              <div class="col-md-10">
                <div class="mb-4 row">
                  <label class="col-sm-4 col-form-label"
                    >Street<span class="text-danger"
                      >*</span
                    ></label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      class="form-control"
                      v-model="street_drive"
                      name="drivestreet"
                      required=""
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-10">
                <div class="mb-4 row">
                  <label class="col-sm-4 col-form-label"
                    >City<span class="text-danger"
                      >*</span
                    ></label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      class="form-control"
                      v-model="city_drive"
                      name="drivecity"
                      required=""
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-10">
                <div class="mb-4 row">
                  <label class="col-sm-4 col-form-label"
                    >Province<span class="text-danger"
                      >*</span
                    ></label
                  >
                  <div class="col-sm-8">
                    <select
                      type="text"
                      @change="onProvinceChange($event)"
                      class="form-control"
                      v-model="province_drive"
                      name="residenceprovince"
                      required=""
                    ><option value="Ontario">Ontario</option>
                    <option value="Quebec">Quebec</option>
                    <option value="British Columbia">British Columbia</option>
                    <option value="Alberta">Alberta</option>
                    <option value="Manitoba">Manitoba</option>
                    <option value="Saskatchewan">Saskatchewan</option>
                    <option value="New Brunswick">New Brunswick</option>
                    <option value="Nova Scotia">Nova Scotia</option>
                    <option value="Prince Edward Island">Prince Edward Island</option>
                    <option value="Yukon">Yukon</option>
                    <option value="Nunavut">Nunavut</option>
                    <option value="Northwest Territories">Northwest Territories</option>
                  </select>
                  </div>
                </div>
              </div>
              <div class="col-md-10">
                <div class="mb-4 row">
                  <label class="col-sm-4 col-form-label"
                    >Postal Code<span class="text-danger"
                      >*</span
                    ></label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      class="form-control drive_postal_code"
                      v-model="postal_drive"
                      name="drivepostal"
                      required=""
                      maxlength="7"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-10">
                <div class="mb-4 row">
                  <label class="col-sm-4 col-form-label"
                    >Country<span class="text-danger"
                      >*</span
                    ></label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      class="form-control"
                      v-model="country_drive"
                      name="drivecountry"
                      required=""
                    />
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          <div class="mb-3 row">
            <h5 class="my-5 personal-head text-black">
                <span>APPLICATION QUESTIONS</span>
              </h5>
            <div class="mb-3 col">
              <div class="col-md-10">
                <div class="mb-4 row">
                  <label class="col-sm-6 col-form-label"
                    >Are you over 18 years of age? (For the purpose of safety and ability to handle hazardous goods)<span class="text-danger"
                      >*</span
                    ></label
                  >
                  <div class="col-sm-6">
                    <select
                      type="text"
                      class="form-control"
                      v-model="of_age_drive"
                      name="driveofage"
                      required=""
                    ><option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  </div>
                </div>
              </div>
              <div class="col-md-10">
                <div class="mb-4 row">
                  <label class="col-sm-6 col-form-label"
                    >Are your license, registration and insurance valid for the province you are applying to work in?<span class="text-danger"
                      >*</span
                    ></label
                  >
                  <div class="col-sm-6">
                    <select
                      type="text"
                      class="form-control"
                      v-model="insured_drive"
                      name="driveinsured"
                      required=""
                    ><option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  </div>
                </div>
              </div>
              <div class="col-md-10">
                <div class="mb-4 row">
                  <label class="col-sm-6 col-form-label"
                    >Which products are you interested in delivering?<span class="text-danger"
                      >*</span
                    ></label
                  >
                  <div class="col-sm-6">
                    <select
                      id="driveProducts"
                      type="text"
                      class="form-control"
                      v-model="products_drive"
                      name="driveproducts"
                      required=""
                    >
                    <option value="Parcels">Parcels</option>
                    <option value="Drop/Bundle Driver">Drop/Bundle Driver</option>
                    <option value="Sub Driver">Sub Driver</option>
                  </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3 col">
              <div class="col-md-10">
                <div class="mb-4 row">
                  <label class="col-sm-4 col-form-label"
                    >What is your availibility for deliveries?<span class="text-danger"
                      >*</span
                    ></label
                  >
                  <div class="col-sm-8">
                    <textarea
                      type="text"
                      rows="5"
                      class="form-control additional_details"
                      v-model="availability_drive"
                      name="driveavail"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="col-md-10">
                <div class="mb-4 row">
                  <label class="col-sm-4 col-form-label"
                    >Additional details</label
                  >
                  <div class="col-sm-8">
                    <textarea
                      type="text"
                      rows="5"
                      class="form-control additional_details"
                      v-model="additional_details_drive"
                      name="fullDescription"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          

          

          <p class="mandatory-fields mb-0">
            <span class="text-danger">*</span> All fields are mandatory
          </p>

          <div class="d-flex justify-content-center my-5 form-buttons">
            <button
              type="button"
              class="btn btn-support btn-outline-dark me-3 button_drive"
              value="submit"
              @click="sendDriveEmail()"
            >
              Submit
            </button>
            <button
              type="reset"
              class="btn btn-support btn-outline-secondary reset"
            >
              Reset
            </button>
          </div>
        </form>
      </div>
      <div id="pickupDetails" class="hide">
        <div class="mb-3">
          <p class="pickup_location"></p>
        </div>
      </div>
      
      <page-footer></page-footer>
</template>
<script>
    import PageFooter from "./PageFooter.vue";
    import PageHeader from "./PageHeader.vue";
    import axios from "axios";
    window.dataLayer = window.dataLayer || [];
    import { parcel_api } from '@/js_utils/urls.js'

    export default {
    beforeMount() {
        scroll(0, 0);
    }, methods: {
      supportTicketSent(success,Id) {
        if (success == true) {
          window.dataLayer.push({
          'event': 'formSuccess',
          'Id': Id
          });
          document.querySelector(".pickup_location").innerHTML =
            "Your application has been submitted, and we will work to get back to you as soon as possible.";
        } else {
          document.querySelector(".pickup_location").innerHTML =
            "We are sorry for the inconvenience, but there was an error submitting your application. Our team has been notified and we are working on a fix.";
        }
        document.querySelector("#pickupDetails").classList.remove("hide");
        document.querySelector("#pickupDetails").scrollIntoView();
        document.querySelector(".button_drive").disabled = false;
        document.querySelector(".siteViewport").classList.remove("greyOut");
        document.querySelector(".supportLoader").hidden = true;

    },
        resetDriveForm() {
          this.full_name_drive = ""
          this.email_address_drive = ""
          this.phone_drive = ""
          this.street_drive = "" 
          this.city_drive = ""
          this.postal_drive = ""
          this.province_drive = ""
          this.country_drive = ""
          this.of_age_drive = ""
          this.products_drive = ""
          this.insured_drive = ""
          this.availability_drive = ""
          this.additional_details_drive = ""
      },
      onProvinceChange(event) {
        var selectObject = document.querySelector("#driveProducts");
        var selectObjectOptionsArray = selectObject.options;
        var selected = event.target.value

        let flyersOptionPosition = null;
        let papersOptionPosition = null;
        
        if(selected === "New Brunswick") {
          flyersOptionPosition = this.getPositionsOfFlyerOption(selectObjectOptionsArray);
          papersOptionPosition = this.getPositionsOfPaperOption(selectObjectOptionsArray);
                  
          if(papersOptionPosition != null || flyersOptionPosition != null) {
            this.removeDriverSelectOptions(selectObject, papersOptionPosition, flyersOptionPosition);
          } else 
            this.addDriverSelectOptions(selectObject);
        } else {
          flyersOptionPosition = this.getPositionsOfFlyerOption(selectObjectOptionsArray);
          papersOptionPosition = this.getPositionsOfPaperOption(selectObjectOptionsArray);

          if(papersOptionPosition != null || flyersOptionPosition != null)
            this.removeDriverSelectOptions(selectObject, papersOptionPosition, flyersOptionPosition);

        }
      },
      getPositionsOfFlyerOption(selectObjectOptionsArray) {
        var flyersOptionPosition = null;
        for(var i = 0 ; i < selectObjectOptionsArray.length ; i++) {
            if(selectObjectOptionsArray[i].value === 'EMC') {
              flyersOptionPosition = i;
            }
          }
        return flyersOptionPosition;
      },
      getPositionsOfPaperOption(selectObjectOptionsArray) {
        var papersOptionPosition = null;
        for(var i = 0 ; i < selectObjectOptionsArray.length ; i++) {
            if(selectObjectOptionsArray[i].value === 'Paper') {
              papersOptionPosition = i;
            }
          }
        return papersOptionPosition;
      },
      addDriverSelectOptions(selectObject) {
        var flyersOption = document.createElement('option');
        var paperOption = document.createElement('option');
        flyersOption.text = 'Flyers (NB Only)';
        flyersOption.value = 'EMC';
        paperOption.text = 'Newspapers (NB Only)';
        paperOption.value = 'Paper';
        selectObject.add(flyersOption);
        selectObject.add(paperOption);
      },
      removeDriverSelectOptions(selectObject, papersOptionPosition, flyersOptionPosition) {
        selectObject.remove(papersOptionPosition);
        selectObject.remove(flyersOptionPosition);
      },
      /* eslint-disable */
      sendDriveEmail() {
        document.querySelector(".button_drive").disabled = true;
        document.querySelector("#driveForUs").disabled = true;
        document.querySelector(".siteViewport").classList.add("greyOut");
        document.querySelector(".supportLoader").hidden = false;
        
        if (
          this.full_name_drive == "" ||
          this.email_address_drive == "" ||
          this.phone_drive == "" ||
          this.street_drive == "" ||
          this.city_drive == "" ||
          this.postal_drive == "" ||
          this.province_drive == "" ||
          this.country_drive == "" ||
          this.of_age_drive == "" ||
          this.products_drive == "" ||
          this.insured_drive == "" ||
          this.availability_drive == ""      ) {
          alert("Please fill out all required fields before submitting.");
          document.querySelector(".button_drive").disabled = false;
          return;
        }

        let email_pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        let email_match = email_pattern.test(this.email_address_drive)

        if(!email_match) {
          alert("Invalid email entered. Please ensure your email matches the following format: example@domain.com");
          document.querySelector(".button_drive").disabled = false;
          document.querySelector("#driveForUs").disabled = false;
          document.querySelector(".drive_email_address").scrollIntoView()
          document.querySelector(".drive_email_address").focus()
          return;
        }
          
        let phone_pattern = /[0-9]{3}\s?[0-9]{3}\s?[0-9]{4}/
        let phone_match = phone_pattern.test(this.phone_drive)

        if(!phone_match) {
          alert("Invalid phone number. Please ensure your phone number matches the following format: 555 555 5555");
          document.querySelector(".button_drive").disabled = false;
          document.querySelector("#driveForUs").disabled = false;
          document.querySelector(".drive_phone_number").scrollIntoView()
          document.querySelector(".drive_phone_number").focus()
          return;
        }

        let postal_pattern = /^\w\d\w\s?\d\w\d$/
        let postal_match = postal_pattern.test(this.postal_drive)

        if(!postal_match) {
          alert("Invalid postal code. Please ensure your postal code matches the following format: Q2P 7Y9");
          document.querySelector(".button_drive").disabled = false;
          document.querySelector("#driveForUs").disabled = false;
          document.querySelector(".drive_postal_code").scrollIntoView()
          document.querySelector(".drive_postal_code").focus()
          return;
        }
        
        let email_body = {
          "name": this.full_name_drive,
          "email": this.email_address_drive,
          "phoneNumber": this.phone_drive,
          "street": this.street_drive,
          "city": this.city_drive,
          "postalCode": this.postal_drive,
          "province": this.province_drive,
          "country": this.country_drive,
          "availability": this.availability_drive,
          "additionalDetails": this.additional_details_drive,
          "ofAge": this.of_age_drive,
          "products": this.products_drive,
          "insuredLicenseValid": this.insured_drive
        };

        axios
          .post(parcel_api.concat('/leads'),
            JSON.stringify(email_body)
          )
          .then((res) => {
            let success;
            let Id = 1003;
            if (res["data"] == 1) success = true;
            else success = false;
            this.resetDriveForm();
            this.supportTicketSent(success,Id);
          })
          .catch((error) => {
            console.log(error);
            this.supportTicketSent(false,0);
          });
      },
    },
    name: "careers-page",
    components: {
      PageHeader,
      PageFooter
    }, data: function() {
        return {
          drive_for_us: false,

          full_name_drive: "",
          email_address_drive: "",
          phone_drive: "",
          street_drive: "",
          city_drive: "",
          province_drive: "",
          postal_drive: "",
          country_drive: "",
          availability_drive: "",
          additional_details_drive: "",
          products_drive: "",
          insured_drive: "",
          of_age_drive: ""
        }
    }
}
</script>